export const envConfig = {
  STUrl: process.env.REACT_APP_ST_URL,
  WZUrl: process.env.REACT_APP_WZ_URL,
  RNUrl: process.env.REACT_APP_RELEASE_NOTE_URL,
  RNMonth: process.env.REACT_APP_RELEASE_NOTE_MONTH,
  TermsUrl: process.env.REACT_APP_TERMS_DOC_URL,
  Staging: process.env.REACT_APP_ISSTAGING,
};
